import { z } from "zod";

export const WORKSPACE_TIMEZONE_OPTIONS = [
  { value: "America/Los_Angeles", label: "Pacific Time (PT)" },
  { value: "America/Denver", label: "Mountain Time (MT)" },
  { value: "America/Chicago", label: "Central Time (CT)" },
  { value: "America/New_York", label: "Eastern Time (ET)" },
  { value: "Europe/London", label: "London (GMT/BST)" },
  { value: "Europe/Paris", label: "Central Europe (CET)" },
  { value: "Asia/Singapore", label: "Singapore (SGT)" },
  { value: "Australia/Sydney", label: "Sydney (AET)" },
] as const;

export type WorkspaceSchemaMessages = {
  nameError: string;
  nameLengthError: string;
  slugError: string;
  timezoneError: string;
};

export type WorkspaceSchema = z.ZodObject<{
  name: z.ZodString;
  slug: z.ZodEffects<z.ZodString, string, string>;
  timezone: z.ZodString;
}>;

export const createWorkspaceSchema = (messages: WorkspaceSchemaMessages): WorkspaceSchema =>
  z.object({
    name: z
      .string()
      .min(2, { message: messages.nameError })
      .max(160, { message: messages.nameLengthError }),
    slug: z
      .string()
      .transform((value) => value.trim().toLowerCase())
      .refine((value) => value.length === 0 || /^[a-z0-9-]{3,48}$/.test(value), {
        message: messages.slugError,
      }),
    timezone: z.string().min(1, { message: messages.timezoneError }),
  });
